import React, { useState } from "react";
import { Box, Button, Typography, TextField, Slider, Chip, Grid, IconButton } from "@mui/material";
import axios from "axios";
import CheckCircleIcon from "@mui/icons-material/CheckCircle";
import AddIcon from "@mui/icons-material/Add";
import RemoveIcon from "@mui/icons-material/Remove";
import { useSelector } from "react-redux";
import ReusableDialog from "../../../../common/dialog/dialog";
import DeleteIcon from "@mui/icons-material/Delete";

const ManagerCoshhProductCheckList = ({ onClose, setOpenDefaultSnackbar }) => {
  const [items, setItems] = useState([
    "Air wick scented gel",
    "Almat non-bio laundry liquid",
    "Astonish mold and mildew blaster",
    "Bin buddy fresh",
    "Bloo 2 in 1 toilet blocks",
    "Bloome oval air aromatic beads",
    "Comfort laundry detergent",
    "Comfort fabric conditioner",
    "Dettol surface cleanser spray and wipes",
    "Dish Matic",
    "Dr Beddmann upholstery stain remover",
    "Duck deep action bathroom gel",
    "Elbow grease washing up liquid",
    "Fabulous fabric freshener",
    "Fabulous kitchen spray",
    "Fabulous multi-purpose cleaning spray",
    "Fairy fabric softer",
    "Fairy platinum plus (All in one) dishwasher tablets",
    "Febreze antibacterial fabric freshener",
    "Flash kitchen spray",
    "Finish Powerball quantum ultimate",
    "Hand safe hand sanitizer",
    "Neutradol carpet deodorizer",
    "Power force bathroom cleaner",
    "Power force all-purpose cleaner",
    "Power force all surface cleaner",
    "Scentcerity room spray",
    "Star drops white vinegar spray",
    "Surf with fragrance release",
    "Tesco anti bac kitchen cleaner with bleach",
    "Tesco anti bac bathroom cleaner spray",
    "Tesco daily shower cleaning spray",
    "Tesco dish washer cleaner",
    "Tesco spring fresh cleaner",
    "Tesco screen wash",
    "The pink stuff floor cleaning spray",
    "Vanish oxi action carpet and Upholstery stain removal spray",
    "Wood floor cleaners",
    "Zoflora multipurpose disinfectant cleaner",
    "Easy toilet cleaner",
    "Nippon Ant crawling insect",
    "Power force kitchen cleaner",
    "Power force fresh (liner)",
    "Magnum washing up",
    "Scentcerity Gel Air",
    "Magnum dishwasher cleaner",
  ]);

  const today = new Date();
  const currentDate = today.toISOString().split("T")[0];
  const user = useSelector((state) => state.auth.user); // User data from Redux store
  const [currentProductIndex, setCurrentProductIndex] = useState(0);
  const [responses, setResponses] = useState([]);
  const [quantity, setQuantity] = useState(1);
  const [amount, setAmount] = useState(50);
  const [comments, setComments] = useState("");
  const [selectedDate, setSelectedDate] = useState(currentDate);
  const [dialogOpen, setDialogOpen] = useState(false);
  const [newItemName, setNewItemName] = useState("");
  const [newItemCount, setNewItemCount] = useState(0);
  const [deleteOpen, setDeleteOpen] = useState(false);

  const handleDialogOpen = () => {
    setDialogOpen(true);
  };

  const handleDialogClose = () => {
    setDialogOpen(false);
    setNewItemName("");
    setNewItemCount(0);
  };

  const handleAddNewItem = () => {
    if (newItemName.trim()) {
      setItems([...items, newItemName]); // Add only the name as a string
      handleDialogClose();
    }
  };

  const handleDeleteItem = (index) => {
    setItems(items.filter((_, i) => i !== index));
    setDeleteOpen(false);
  };

  const handleNext = () => {
    setResponses([
      ...responses,
      {
        product: items[currentProductIndex],
        quantity,
        amount: `${amount}%`,
        comments,
        date: selectedDate,
      },
    ]);
    setQuantity(1);
    setAmount(50);
    setComments("");

    if (currentProductIndex < items.length - 1) {
      setCurrentProductIndex((prev) => prev + 1);
    } else {
      handleSubmit();
    }
  };

  const handleSubmit = async () => {
    // Ensure responses array is not empty and created_by is set
    if (responses.length === 0 || !user?.username) {
      alert("Please complete the checklist before submitting.");
      return;
    }

    // Prepare payload
    const payload = {
      products: responses.map((response) => ({
        product: response.product, // Ensure correct key name
        quantity: response.quantity,
        amount: response.amount,
        comments: response.comments,
        date: response.date,
      })),
      created_by: user.username, // Ensure created_by is included
      created_at: currentDate,
    };

    try {
      await axios.post("/api/product/productCheck", payload, {
        headers: { "Content-Type": "application/json", "x-user-role": user?.roleid },
      });

      setResponses([]);
      setQuantity(1);
      setAmount(50);
      setComments("");
      setSelectedDate(currentDate);
      onClose();
      setOpenDefaultSnackbar(true);
    } catch (error) {
      console.error("Error submitting responses:", error);
      // Check if the error is due to a duplicate time/created_at combination
      if (error.response && error.response.status === 409) {
        alert("Weekly COSHH Product Check with the same date already exists.");
      }
    }
  };

  const handleQuantityChange = (change) => {
    setQuantity((prev) => Math.max(0, prev + change));
  };

  return (
    <Box sx={{ p: 4, m: 2 }}>
      <Chip
        variant='contained'
        sx={{ fontSize: "14px", backgroundColor: "#F2F6FF", color: "#1751D0" }}
        label='Weekly Tasks'
      />

      <Typography sx={{ fontSize: "24px", color: "black", fontWeight: "bold", mb: 1 }}>
        Weekly COSHH Product Check
      </Typography>

      <Typography variant='subtitle2' sx={{ color: "#757575", mb: 1 }}>
        Date: {currentDate} &nbsp; • &nbsp; <span style={{ color: "#1751D0" }}>Kindergarten Bedroom</span>
      </Typography>

      <Typography variant='subtitle2' sx={{ color: "#757575", fontSize: "14px", mb: 2 }}>
        <Grid container>
          <Grid item xs={5} sx={{ color: "#1751D0" }}>
            Product {currentProductIndex + 1} of {items.length} Complete!
          </Grid>
          <Grid item xs={4}>
            <span style={{ color: "#1751D0" }}>{currentProductIndex + 1} </span>
            {`/ ${items.length}`}
          </Grid>
        </Grid>
      </Typography>

      <Grid container spacing={3}>
        <Grid item xs={6}>
          {items.map((product, index) => (
            <Box
              key={index}
              sx={{
                display: "flex",
                justifyContent: "space-between",
                alignItems: "center",
                borderBottom: "1px solid #E0E0E0",
                py: 1,
              }}
            >
              <Typography sx={{ flex: 1, color: "black", fontSize: "14px" }}>{`${index + 1} ${product}`}</Typography>
              <IconButton
                color='primary'
                sx={{
                  color: responses.find((response) => response.product === product) ? "#1751D0" : "#E0E0E0",
                }}
              >
                <CheckCircleIcon />
              </IconButton>
            </Box>
          ))}
        </Grid>

        <Grid item xs={6}>
          <Box sx={{ display: "flex", justifyContent: "flex-end", mb: 2 }}>
            <Button variant='contained' onClick={handleDialogOpen}>
              Add New Item
            </Button>
          </Box>
          <ReusableDialog
            isOpen={dialogOpen}
            onClose={handleDialogClose}
            title='Add A Item'
            onSubmit={handleAddNewItem}
            submitText='Submit'
            cancelText='Cancel'
          >
            <Typography sx={{ fontSize: "14px", color: "black" }}>Item Name</Typography>
            <TextField
              name='itemName'
              fullWidth
              variant='outlined'
              value={newItemName}
              onChange={(e) => setNewItemName(e.target.value)}
              sx={{ mb: 2 }}
            />

            <Typography sx={{ fontSize: "14px", color: "black", mb: 1 }}>Count Available</Typography>
            <Box sx={{ display: "flex", alignItems: "center", gap: 1, mb: 2 }}>
              <TextField
                name='itemCount'
                value={newItemCount}
                size='small'
                type='number'
                inputProps={{ style: { textAlign: "center", width: "60px" } }}
                onChange={(e) => setNewItemCount(Number(e.target.value))}
              />
              <IconButton color='primary' onClick={() => setNewItemCount((prev) => Math.max(prev - 1, 0))}>
                <RemoveIcon />
              </IconButton>
              <IconButton color='primary' onClick={() => setNewItemCount((prev) => prev + 1)}>
                <AddIcon />
              </IconButton>
            </Box>
          </ReusableDialog>
          <Grid container>
            <Grid item xs={11}>
              <Typography sx={{ fontSize: "14px", mb: 2 }}>
                Product: <br />
                {items[currentProductIndex]}
              </Typography>
            </Grid>
            <Grid item xs={1}>
              <IconButton color='primary' size='small' onClick={() => setDeleteOpen(true)}>
                <DeleteIcon />
              </IconButton>
            </Grid>
          </Grid>
          <ReusableDialog
            isOpen={deleteOpen}
            onClose={() => setDeleteOpen(false)}
            title='Delete Product Item'
            submitText='Yes, delete this item'
            cancelText='Cancel, keep this item'
            contentText={`Are you sure you want to delete the product item named "${items[currentProductIndex]}"?`}
            onSubmit={() => handleDeleteItem(currentProductIndex)}
            maxWidth='md'
          />

          <Typography sx={{ fontSize: "14px", mb: 2 }}>Quantity</Typography>
          <Box sx={{ display: "flex", alignItems: "center", gap: 1, mb: 2 }}>
            <Button variant='outlined' color='primary' onClick={() => handleQuantityChange(-1)}>
              -
            </Button>
            <Typography>{quantity}</Typography>
            <Button variant='outlined' color='primary' onClick={() => handleQuantityChange(1)}>
              +
            </Button>
          </Box>

          <Typography sx={{ fontSize: "14px", mb: 2 }}>Amount</Typography>
          <Box sx={{ display: "flex", alignItems: "center", gap: 2, mb: 2 }}>
            <Typography>{amount}%</Typography>
            <Slider value={amount} onChange={(e, value) => setAmount(value)} min={0} max={100} step={1} />
          </Box>

          <Typography sx={{ fontSize: "14px", mt: 2, mb: 2 }}>Comments</Typography>
          <TextField fullWidth multiline rows={3} value={comments} onChange={(e) => setComments(e.target.value)} />
        </Grid>
      </Grid>

      <Box sx={{ display: "flex", justifyContent: "flex-end", gap: 2, mt: 4 }}>
        {currentProductIndex === 0 && (
          <Button variant='outlined' color='primary' onClick={() => onClose()}>
            Cancel
          </Button>
        )}
        {currentProductIndex > 0 && (
          <Button variant='outlined' color='primary' onClick={() => setCurrentProductIndex((prev) => prev - 1)}>
            Previous
          </Button>
        )}
        {currentProductIndex < items.length - 1 ? (
          <Button variant='contained' color='primary' onClick={handleNext} disabled={quantity === 0 || !comments}>
            Next
          </Button>
        ) : (
          <Button variant='contained' color='primary' onClick={handleSubmit} disabled={quantity === 0 || !comments}>
            Submit
          </Button>
        )}
      </Box>
    </Box>
  );
};

export default ManagerCoshhProductCheckList;
